import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const PillLabelStyled = styled.div.attrs({
  className: 'PillLabelStyled',
})`
  width: fit-content;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  background-color: ${themed('primary.lightGray')};

  .Text {
    margin-bottom: 0;
    line-height: normal;
    font-size: 0.75rem;
    position: relative;
    top: 1px;
  }
`;
